export default "<div class=\"step\" [hidden]=\"!active\">\n  <ng-content></ng-content>\n</div>\n"